import { useOnlineOrdersStorage } from '../storage';
import { useGetLayoutSize } from '../../../components-shared/LayoutSizeProvider';
import { RequestStatus } from '../../../utils/wrapRequest';

type WidgetState = 'loading' | 'empty' | 'content';

const deriveWidgetState = (
  fetchMenusStatus: RequestStatus,
  menusCount: number,
): WidgetState => {
  if (fetchMenusStatus === RequestStatus.RESOLVED && menusCount === 0) {
    return 'empty';
  }

  if (fetchMenusStatus === RequestStatus.RESOLVED && menusCount > 0) {
    return 'content';
  }

  return 'loading';
};

export const useHooks = () => {
  const { layoutSize } = useGetLayoutSize();
  const { menus, fetchMenusStatus } = useOnlineOrdersStorage();

  const widgetState = deriveWidgetState(fetchMenusStatus, menus.length);

  return {
    layoutSize,
    widgetState,
  };
};
